import { ReferralActions } from '../actions/actionTypes'
import { IReferralsStore, ReferralsInterface } from '../Interfaces/ReferralInterface'
import { ReducerBuilder } from './ReducerBuilder'

const initialState: IReferralsStore = {
  loaded: false,
}

const setReferrals = (state: IReferralsStore, payload: ReferralsInterface) => ({
  loaded: true,
  referrals: payload,
})

export default new ReducerBuilder<IReferralsStore, ReferralsInterface>(initialState)
  .mapAction(ReferralActions.LOAD_REFERRALS, setReferrals)
  .build()
